export class FooterLogo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false

    this.paths = this.els?.path?.elements
    this.footer = this.externalEls?.footer?.element

    this.checkScroll()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.checkScroll = this.checkScroll.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    window.addEventListener('resize', this.checkScroll)
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.checkScroll)

    this.isTicking = true
  }

  checkScroll () {
    this.isTicking = false

    const rectThis = this.getBoundingClientRect()
    const rectFooter = this.footer.getBoundingClientRect()
    const start = rectThis.top
    const end = rectFooter.bottom
    const totalScroll = end - start

    const scrolled = window.innerHeight - start

    let scrollPercentage = Math.max(
      0,
      Math.min(100, (scrolled / totalScroll) * 100),
    )
    if (scrollPercentage > 100) scrollPercentage = 100
    if (scrollPercentage <= 0) return

    this.paths.forEach((path) => {
      this.updatePathOffset(path, scrollPercentage)
    })
  }

  updatePathOffset (path, scrollPercentage) {
    const weight = parseFloat(path.dataset.animationWeight)
    if (scrollPercentage < weight) return

    const pathScrollPercentRange = 100 - weight
    const weightedProgress = Math.min(
      1,
      (scrollPercentage - weight) / pathScrollPercentRange,
    )

    const offsetValue =
      parseFloat(this.dataset.translateBasePercent) * (1 - weightedProgress)

    path.style.setProperty('--FooterLogo_Offset', `${offsetValue}%`)
  }
}

if (!customElements.get('footer-logo')) {
  customElements.define('footer-logo', FooterLogo)
}
